import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './SettingsLogs.css';

function UserLogs({ tableData }) {
    return (
        <div className="settings_logs-container">
            {tableData.data.length > 1 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No existen logs</h4>
            )}
        </div>
    );
}

export default UserLogs;
